
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5881',
  depVersions: {
  "data-privacy-request-ui": "static-1.5881",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10009",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8395",
  "hub-http-shared-msw-handlers": "static-1.10709",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11850",
  "I18n": "static-7.1681",
  "jasmine-runner": "static-1.6808",
  "quartz": "static-1.7525",
  "react-dlb": "static-1.90",
  "rpc-client-utils": "static-1.5024",
  "ui-components-test-utils": "static-1.5987",
  "UIComponents": "static-3.8796",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.95",
  "foundations-assets": "static-1.5245",
  "foundations-components": "static-1.8573",
  "foundations-components-test-utils": "static-1.6056",
  "foundations-theming": "static-1.4837",
  "hub-http": "static-1.6571",
  "quartz-config": "static-1.1303",
  "quartz-core": "static-1.6744",
  "quartz-routing": "static-1.955",
  "quick-fetch": "static-1.4159",
  "raven": "static-3.5925",
  "react": "static-7.199",
  "react-rhumb": "static-1.17084",
  "SharedI18nStrings": "static-1.184",
  "ui-addon-i18n": "static-1.11506",
  "usage-tracker": "static-1.7671",
  "usage-tracker-anonymous": "static-1.6088",
  "usage-tracker-core": "static-1.7521",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3802",
  "quartz-webpack": "static-1.3749",
  "bend-plugin-quartz-routing": "static-1.603",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.90",
  "HeadJS": "static-2.805",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3506",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "ts-schema": "static-1.4330",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "react-utils": "static-2.5593",
  "StyleGuideUI": "static-3.509",
  "jasmine": "static-4.4671",
  "bend-plugin-chirp-manifest": "static-1.434",
  "chirp-fetch": "static-1.2256",
  "HubStyle": "static-2.12157",
  "ui-addon-draggable": "static-3.5106",
  "cssUtils": "static-1.982",
  "hs-story-utils": "static-1.9783",
  "icons": "static-2.695",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-virtualized": "static-2.108",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-components": "static-1.4842",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2553",
  "react-aria": "static-1.73",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2783",
  "ui-fonts": "static-1.1112",
  "foundations-components-legacy": "static-1.1598",
  "bend-plugin-foundations-theming": "static-1.3320",
  "foundations-theming-base": "static-1.3822",
  "stylex": "static-1.42",
  "hs-locale-management": "static-1.331",
  "opentelemetry-fe-types": "static-1.138",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.513",
  "quartz-auth": "static-1.1200",
  "quartz-head": "static-1.1190",
  "quartz-i18n": "static-1.1200",
  "quartz-test": "static-1.1200",
  "quartz-tracking": "static-1.904",
  "trellis-components": "static-1.2802",
  "usage-tracker-container": "static-1.7661",
  "csstype": "static-1.50",
  "web-vitals": "static-1.16",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3452",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.79",
  "sassPrefix": "static-1.248",
  "stylex-utils": "static-1.149",
  "trellis-theming": "static-1.1333",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.64",
  "hubspotter-http-shared-msw-handlers": "static-1.10707",
  "usage-tracker-session-replay": "static-1.5357",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5881",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10009",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8395",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10709",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11850",
  "I18n": "/I18n/static-7.1681",
  "jasmine-runner": "/jasmine-runner/static-1.6808",
  "quartz": "/quartz/static-1.7525",
  "react-dlb": "/react-dlb/static-1.90",
  "rpc-client-utils": "/rpc-client-utils/static-1.5024",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5987",
  "UIComponents": "/UIComponents/static-3.8796",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "foundations-assets": "/foundations-assets/static-1.5245",
  "foundations-components": "/foundations-components/static-1.8573",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6056",
  "foundations-theming": "/foundations-theming/static-1.4837",
  "hub-http": "/hub-http/static-1.6571",
  "quartz-config": "/quartz-config/static-1.1303",
  "quartz-core": "/quartz-core/static-1.6744",
  "quartz-routing": "/quartz-routing/static-1.955",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.199",
  "react-rhumb": "/react-rhumb/static-1.17084",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11506",
  "usage-tracker": "/usage-tracker/static-1.7671",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6088",
  "usage-tracker-core": "/usage-tracker-core/static-1.7521",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3802",
  "quartz-webpack": "/quartz-webpack/static-1.3749",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.603",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.90",
  "HeadJS": "/HeadJS/static-2.805",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3506",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "ts-schema": "/ts-schema/static-1.4330",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "react-utils": "/react-utils/static-2.5593",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "jasmine": "/jasmine/static-4.4671",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.434",
  "chirp-fetch": "/chirp-fetch/static-1.2256",
  "HubStyle": "/HubStyle/static-2.12157",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5106",
  "cssUtils": "/cssUtils/static-1.982",
  "hs-story-utils": "/hs-story-utils/static-1.9783",
  "icons": "/icons/static-2.695",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-virtualized": "/react-virtualized/static-2.108",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4842",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2553",
  "react-aria": "/react-aria/static-1.73",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2783",
  "ui-fonts": "/ui-fonts/static-1.1112",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1598",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3320",
  "foundations-theming-base": "/foundations-theming-base/static-1.3822",
  "stylex": "/stylex/static-1.42",
  "hs-locale-management": "/hs-locale-management/static-1.331",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.138",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.513",
  "quartz-auth": "/quartz-auth/static-1.1200",
  "quartz-head": "/quartz-head/static-1.1190",
  "quartz-i18n": "/quartz-i18n/static-1.1200",
  "quartz-test": "/quartz-test/static-1.1200",
  "quartz-tracking": "/quartz-tracking/static-1.904",
  "trellis-components": "/trellis-components/static-1.2802",
  "usage-tracker-container": "/usage-tracker-container/static-1.7661",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.16",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.79",
  "sassPrefix": "/sassPrefix/static-1.248",
  "stylex-utils": "/stylex-utils/static-1.149",
  "trellis-theming": "/trellis-theming/static-1.1333",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.64",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10707",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5357",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
